<app-feature-details-grid>
  <app-feature-list-container>
    <app-feature-list-item
      *ngIf="operatingProgramsActive$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PROGRAM' | translate }}"
      [value]="operatingProgramName$ | async | translate"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <ng-container feature *ngIf="circuitHeatingCurvePresets$ | async | ready as feature">
      <app-feature-list-item
        *ngIf="feature | value2: featurePropertyKey.active"
        label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PRESETS.TITLE' | translate }}"
        [value]="feature.properties?.value?.value | translateHeatingCurvePresets"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
    </ng-container>
    <ng-container
      *ngIf="circuitConfigurationRegulation$ | async | ready as circuitConfigurationRegulation"
    >
      <app-feature-list-item
        label="{{
          '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.CONFIGURATION_REGULATION.TITLE' | translate
        }}"
        [value]="
          circuitConfigurationRegulation.properties?.mode?.value
            | translateHeatingConfigurationRegulation
        "
        [attr.data-feature]="circuitConfigurationRegulation.feature"
      >
      </app-feature-list-item>
      <ng-container
        *ngIf="targetSupplyTemperature$ | async | ready as targetSupplyTemperatureFeature"
      >
        <app-temperature-select
          *ngIf="
            (circuitConfigurationRegulation | value2: featurePropertyKey.mode) ===
              HeatingConfigurationRegulationMode.ConstantControlled &&
            (targetSupplyTemperatureFeature | executable: FeatureCommands.setTemperature)
          "
          [isTile]="true"
          [title]="
            '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.TARGET_SUPPLY_TEMPERATURE.TITLE' | translate
          "
          [rangeDefinition]="
            targetSupplyTemperatureFeature
              | constraints: FeatureCommands.setTemperature:FeatureActionFields.temperature
          "
          [value]="targetSupplyTemperatureFeature?.properties?.value?.value"
          [attr.data-feature]="targetSupplyTemperatureFeature.feature"
          (valueChange)="onTargetSupplyTemperatureChange($event)"
        >
        </app-temperature-select>
      </ng-container>
    </ng-container>

    <app-feature-list-item
      *ngIf="circuitSensorsTemperature$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.FLOW_TEMPERATURE.TITLE' | translate }}"
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
  </app-feature-list-container>
</app-feature-details-grid>

<h2>
  {{ '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.OPERATING_MODE.TITLE' | translate }}
</h2>
<app-circuit-operating-mode-panel [circuitId]="circuitId"> </app-circuit-operating-mode-panel>

<ng-container *ngIf="heatingCurve$ | async | ready">
  <div class="divider"></div>
  <h2>
    {{ '+INSTALLATIONS.INSTALLATION.HEATING_CIRCUIT_OVERLAY.HEATING_CURVE.TITLE' | translate }}
  </h2>
  <app-heat-curve-panel [circuitId]="circuitId"></app-heat-curve-panel>
</ng-container>
